import http from "@/services/http";

export default {
  install(App) {
    App.config.globalProperties.$http = http;
  }
};
